<!--
 * @Author: luoguo
 * @Date: 2024-01-23 10:39:05
 * @LastEditTime: 2024-01-31 17:17:03
 * @LastEditors: luoguo
 * @Description:
-->
<!--
Author: LiuBo
Date: 2018-09-18
Desc: 页面组件组合生成组件，由router.js 配置引入
-->
<template>
    <div class="view-dynaview view">
        <div
            :is="item.code"
            v-for="item in compData"
            :key="item.code"
            :option="item.option"
            :comp_name="item.name"
            :comp_code="item.code"
        />
    </div>
</template>
<script>
import Vue from "vue";
import conf from "@/config/index";
import log from "@/assets/js/log";
import { getHomePopupQueue, resetHomePopupQueue } from "@/util/homePopupQueue";
import { registerHomeDeferredAcctDialogs } from "@/util/util_jfit";
export default {
    data() {
        return {
            compData: []
        };
    },
    mounted() {
        this.loadRouter();
        // 首页引导弹窗队列：由各子组件注册步骤，按顺序逐个弹出
        if (this.$route.name === "home") {
            if (this.$util.isWebQueryMode()) return;
            resetHomePopupQueue();
            const queue = getHomePopupQueue();
            queue.setVm(this);
            queue.setActive(true);
            this.checkAccountStatus(queue);
            registerHomeDeferredAcctDialogs(queue);
        }
    },
    beforeDestroy() {
        const queue = getHomePopupQueue();
        queue.setActive(false);
    },
    methods: {
        // 检查账户状态，未开户则向队列注册引导弹窗
        checkAccountStatus(queue) {
            const userInfo = this.$cache.getUserOtherInfo();
            // 检查是否未开户（isbind === "0"）
            if (userInfo && userInfo.isbind === "0") {
                queue.addStep({
                    id: "noOpenGuide",
                    order: 1,
                    shouldShow: async (vm) => {
                        if (vm.$util.isWebQueryMode()) return false;
                        const info = vm.$cache.getUserOtherInfo();
                        return (
                            info &&
                            info.isbind === "0" &&
                            !sessionStorage.getItem("_showNoOpenGuide")
                        );
                    },
                    show: (vm) => {
                        // eslint-disable-next-line no-console
                        return vm
                            .$confirm(
                                "您的账户尚未开户，暂时无法进行购买/定投基金等交易功能，是否立即前往开户",
                                "温馨提示",
                                {
                                    confirmButtonText: "确定",
                                    cancelButtonText: "暂不开户",
                                    type: "warning"
                                }
                            )
                            .then(() => vm.$router.push({ name: "bindacctway" }))
                            .catch(() => {
                                // 用户选择暂不开户，留在首页
                            })
                            .then(() => {
                                sessionStorage.setItem("_showNoOpenGuide", "1");
                            });
                    }
                });
            }
        },
        loadRouter() {
            let _route = this.$route.name;
            conf.defaultRoute = _route;
            let confData = conf.views[_route];
            // 首页我的资产推荐广告
            if (_route === "home") {
                const _x = this.$cache.getAdvertiseInfo("2");
                if (_x.length > 0 && confData.components[0].code !== "ad") {
                    const _y = JSON.stringify({ type: "carousel", data: _x });
                    confData.components.unshift({
                        code: "ad",
                        name: "轮播广告",
                        component: (resolve) => require(["@/bizcomponents/misc/ad.vue"], resolve),
                        option: _y
                    });
                }
            }
            if (!confData) {
                this.$alert("动态视图[" + _route + "]的组件信息未找到!", "", {
                    confirmButtonText: "确定",
                    type: "error"
                });
            }
            if (confData.components[confData.components.length - 1].code !== "hint") {
                const _x = this.$cache.getNotice(_route);
                if (_x && _x !== "") {
                    confData.components.push({
                        code: "hint",
                        name: "温馨提示",
                        component: (resolve) => require(["@/bizcomponents/misc/hint.vue"], resolve),
                        option: JSON.stringify({
                            className: "bizcomp-border",
                            data: _x
                        })
                    });
                }
            }
            log.info("加载动态视图...", confData);
            let compData = confData.components;
            let cachedRegistry = this.$cache.get("REGISTEREDCOMPS") || {};
            for (let d of compData) {
                this.compData.push(d);
                if (!cachedRegistry[d.code]) {
                    Vue.component(d.code, d.component);
                    cachedRegistry[d.code] = true;
                    this.$cache.set("REGISTEREDCOMPS", cachedRegistry);
                }
            }
        }
    }
};
</script>
